var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMetamask(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 32,
    viewBox: "0 0 33 32",
    width: 33,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "m29.1176 2-10.9435 8.7511 2.0404-5.15881z",
    fill: "#e17726",
    stroke: "#e17726"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.8825 2 10.8435 8.8232-1.9405-5.22191zm21.2957 20.2843-2.915 4.8077 6.238 1.8547 1.7823-6.5544zm-22.45335.108 1.77395 6.5544 6.2213-1.8547-2.89828-4.8077z",
    fill: "#e27625",
    stroke: "#e27625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.387 14.1632-1.73234 2.8271 6.16304.3061-.1999-7.1756-4.2308 4.0514zm12.226.009-4.2974-4.1414-.1416 7.2656 6.163-.3061zm-11.8929 12.9197 3.7394-1.9447-3.2147-2.701zm7.8287-1.9537 3.7144 1.9537-.4997-4.6547z",
    fill: "#e27625",
    stroke: "#e27625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.2632 27.0922-3.7144-1.9447.2998 2.6109-.0333 1.1074zm-11.5431 0 3.4646 1.7736-.025-1.1074.2998-2.6109z",
    fill: "#d5bfb2",
    stroke: "#d5bfb2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.243 20.7087-3.0815-.9723 2.182-1.0804.9078 2.0527zm4.5057 0 .9161-2.0617 2.1903 1.0804-3.1064.9903z",
    fill: "#233447",
    stroke: "#233447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.7201 27.0919.5413-4.8078-3.43962.1081zm11.0184-4.8078.5247 4.8078 2.9149-4.6997zm2.6068-5.2939-6.163.3061.5663 3.4213.9161-2.0708 2.1904 1.0804zm-13.1838 2.746 2.182-1.0804.9078 2.0528.5746-3.4213-6.16296-.2971z",
    fill: "#cc6228",
    stroke: "#cc6228"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.66284 16.9902 2.58176 5.447-.0832-2.701zm13.19216 2.746-.0999 2.701 2.5817-5.447zm-7.0292-2.4399-.5829 3.4213.7329 4.0334.1665-5.3209zm3.348 0-.2998 2.1248.1499 5.3299.7246-4.0424-.5747-3.4213z",
    fill: "#e27525",
    stroke: "#e27525"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.7487 20.7087-.7246 4.0424.5247.3962 3.2064-2.701.1-2.71zm-7.5872-.9724.0833 2.701 3.2148 2.701.5163-.3872-.7245-4.0424-3.0982-.9724z",
    fill: "#f5841f",
    stroke: "#f5841f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.8236 28.8654.025-1.1074-.2832-.2521h-4.1309l-.2748.2521.025 1.1074-3.4646-1.7736 1.2159 1.0804 2.4569 1.8276h4.2058l2.4652-1.8366 1.1993-1.0714-3.4479 1.7736z",
    fill: "#c0ac9d",
    stroke: "#c0ac9d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.5488 25.1381-.5246-.3871h-3.0482l-.5164.3961-.2998 2.611.2748-.2521h4.1309l.2832.2521-.2999-2.611z",
    fill: "#161616",
    stroke: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.5839 11.3183.9161-4.81669-1.3825-4.50161-10.577 8.463 4.0725 3.7004 5.7466 1.8096 1.2659-1.5936-.5497-.4321.8745-.8643-.6662-.5582.8744-.7203-.5829-.4862zm-27.0839-4.82569.93278 4.82569-.59964.4772.89113.7203-.66627.5672.86615.8643-.54967.4321 1.26591 1.5936 5.74661-1.8006 4.0725-3.7184-10.57699-8.454z",
    fill: "#763e1a",
    stroke: "#763e1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.3596 15.973-5.7466-1.8006 1.7323 2.818-2.5818 5.4469 3.4147-.045h5.1053zm-17.9726-1.8096-5.74662 1.8096-1.91553 6.4193h5.1053l3.41465.045-2.58181-5.4469 1.73231-2.827zm7.787 3.1331.3748-6.8425 1.6656-4.86171h-7.4289l1.6657 4.86171.3748 6.8425.1416 2.1428v5.3119h3.0565l.0166-5.3119z",
    fill: "#f5841f",
    stroke: "#f5841f"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamask);
export default __webpack_public_path__ + "static/media/metamask.c813ebf5418b75ee340b0addfeeb75a1.svg";
export { ForwardRef as ReactComponent };